import { render, staticRenderFns } from "./PreviewCreate.vue?vue&type=template&id=03b7fd68&lang=pug"
import script from "./PreviewCreate.vue?vue&type=script&lang=js"
export * from "./PreviewCreate.vue?vue&type=script&lang=js"
import style0 from "./PreviewCreate.vue?vue&type=style&index=0&id=03b7fd68&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports